<template>
  <div class="share-button" :style="{ 'background-image': `url(${picto})` }">
    <span class="share-button__label">{{ label }}</span>
  </div>
</template>

<script>
export default {
  props: {
    label: { type: String, default: 'share' },
    picto: { type: String, default: null },
  },
};
</script>

<style lang="stylus" scoped>
.share-button {
  position relative
  display block
  width 46px
  height @width

  background-repeat no-repeat
  background-position center
  background-size 16px
  cursor pointer

  &:after {
    content ''
    position absolute
    left 0
    right 0
    bottom 0
    width 100%
    height 1px
    background-color black
    background-color currentColor
    transition transform 0.25s
  }

  &:hover {
    &:after {
      transform scale3d(0, 1, 1)
    }
  }
}

.share-button__label {
  width 0
  height 0
  opacity 0
  overflow hidden
}
</style>
